/* 1InstaPhone · Bundle-Leiste. Quelle und Notizen: snippets/bf-bundle.liquid */
(function () {
  'use strict';
  if (window.__bfBundle) return;
  window.__bfBundle = true;

  var C = window.BF_BUNDLE || {};
  var AKTION = C.aktion || [];
  var istAktionsProdukt = C.template === 'product' && AKTION.indexOf(C.type) >= 0;

  function store(area) {
    return {
      get: function (k) { try { return JSON.parse(window[area].getItem(k)); } catch (e) { return null; } },
      set: function (k, v) { try { window[area].setItem(k, JSON.stringify(v)); } catch (e) {} }
    };
  }
  var LS = store('localStorage'), SS = store('sessionStorage');
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; return e; }
  function hatCode() { return /(?:^|;\s*)discount_code=[^;]+/.test(document.cookie); }
  function zaehlen(cart) {
    var k = 0;
    (cart.items || []).forEach(function (it) { if (AKTION.indexOf(it.product_type) >= 0) k += it.quantity; });
    return k;
  }
  function holeCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  /* ---------- Texte (alle fest, keine Fremddaten) ---------- */
  var CODE_HINWEIS = '<div class="bfb-code">Mit deinem Rabattcode rechnet die Kasse automatisch das Günstigere für dich.</div>';
  function codeHinweis() { return hatCode() ? CODE_HINWEIS : ''; }
  function euro(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }
  function leistenText(n) {
    var r = n % 3;
    if (r === 1) return 'Noch <b>2 Hüllen</b> bis zur Gratis-Hülle';
    if (r === 2) return '<b>Noch 1 Hülle</b>, dann ist eine geschenkt';
    var g = n / 3;
    return '<b>' + (g === 1 ? 'Eine Hülle' : g + ' Hüllen') + ' geschenkt.</b> Noch 2, dann die nächste.';
  }
  function punkte(n) {
    var r = n % 3, voll = n > 0 && r === 0, h = '';
    for (var i = 1; i <= 3; i++) {
      var done = voll || i <= r, gift = i === 3;
      h += '<span class="bfb-dot' + (gift ? ' gift' : '') + (done ? ' done' : '') + '">' + (gift ? '🎁' : (done ? '✓' : i)) + '</span>';
    }
    return '<span class="bfb-dots">' + h + '</span>';
  }

  /* ---------- Leiste unter dem Kopf ---------- */
  var leiste = null;
  function zeigeLeiste(n) {
    if (!leiste) {
      var kopf = document.querySelector('.shopify-section--header');
      if (!kopf || !kopf.parentNode) return;
      leiste = el('div', 'bfb-bar');
      kopf.parentNode.insertBefore(leiste, kopf.nextSibling);
    }
    if (n < 1) { leiste.style.display = 'none'; return; }
    leiste.style.display = '';
    leiste.innerHTML = punkte(n) + '<span class="bfb-bar-t">' + leistenText(n) + '</span>';
  }

  /* ---------- Produktseite: Abzeichen + Reiter ---------- */
  var reiter = null, panel = null;
  function baueProduktseite() {
    // Die Galerie kommt von einer App (pwzrswiper) und laedt spaeter als die Seite. Theme-Galerie nur als Rueckfall.
    var tries = 0;
    var gi = setInterval(function () {
      var galerie = document.getElementById('pwzrswiper-container-wrapper');
      if (!galerie) { var t = document.querySelector('product-media.product__media .product__media-list-wrapper'); if (t && t.offsetHeight > 0) galerie = t; }
      if (!galerie) { if (++tries > 30) clearInterval(gi); return; }
      clearInterval(gi);
      if (galerie.querySelector('.bfb-badges')) return;
      galerie.classList.add('bfb-rel');
      galerie.appendChild(el('div', 'bfb-badges', '<span class="bfb-b1">KAUFE 3 · ZAHLE 2</span><span class="bfb-b2">1 HÜLLE GRATIS</span>'));
    }, 400);
    var varianten = document.querySelector('.product__info .product-form .product-form__variants') ||
                    document.querySelector('.product__info .product-form .product-form__buy-buttons');
    if (!varianten || document.querySelector('.bfb-tabs')) return;
    // Bundle zuerst und standardmaessig offen (Patrick 08.10.)
    reiter = el('div', 'bfb-tabs',
      '<button type="button" data-t="bundle"><span class="bfb-tl">3er-Bundle <span class="bfb-tag">1 GRATIS</span></span>' +
      (C.price ? '<span class="bfb-spar">bis zu ' + euro(C.price) + ' sparen</span>' : '') + '</button>' +
      '<button type="button" data-t="single">Nur diese Hülle</button>');
    panel = el('div', 'bfb-panel');
    varianten.parentNode.insertBefore(reiter, varianten);
    varianten.parentNode.insertBefore(panel, varianten);
    reiter.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-t]'); if (!b) return;
      SS.set('bfb_tab', b.getAttribute('data-t'));
      malePanel(stand);
    });
  }
  function malePanel(n) {
    if (!reiter) return;
    var tab = SS.get('bfb_tab') || 'bundle';
    [].forEach.call(reiter.querySelectorAll('button'), function (b) { b.classList.toggle('on', b.getAttribute('data-t') === tab); });
    reiter.classList.toggle('solo', tab !== 'bundle');
    if (tab !== 'bundle') { panel.style.display = 'none'; return; }
    panel.style.display = '';
    var r = n % 3;
    // Drei Plaetze: erledigte gruen, der aktuelle zeigt diese Huelle, der dritte ist das Geschenk.
    var plaetze = [
      { leer: '<span class="bfb-ico">📱</span><span>Deine Hülle</span>' },
      { leer: '<span class="bfb-ico">＋</span><span>2. Hülle</span>' },
      { leer: '<span class="bfb-ico">🎁</span><span>3. Hülle geschenkt</span>', gift: true }
    ];
    var h = '<div class="bfb-slots">';
    plaetze.forEach(function (pl, i) {
      var cls = 'bfb-slot' + (pl.gift ? ' gift' : ''), inhalt = pl.leer;
      if (i < r) { cls += ' done'; inhalt = '<span class="bfb-ico">✓</span><span>Im Warenkorb</span>'; }
      else if (i === r) { cls += ' now'; inhalt = '<img class="bfb-pimg" alt=""><span>' + (pl.gift ? 'Diese ist geschenkt' : (i === 0 ? 'Deine Hülle' : 'Diese Hülle')) + '</span>'; }
      if (i) h += '<span class="bfb-plus">+</span>';
      h += '<div class="' + cls + '">' + inhalt + '</div>';
    });
    h += '</div>';
    if (r === 0 && C.price) {
      // Patrick 08.10.: keinen Endpreis zeigen, nur die Ersparnis wie am Reiter.
      h += '<div class="bfb-sum"><span>3 Hüllen</span><b>Du sparst bis zu ' + euro(C.price) + '</b></div>' +
        '<div class="bfb-line">Alle Designs frei wählbar, auch mit eigenem Foto. Dein Handymodell merken wir uns.</div>';
    } else if (r === 1) {
      h += '<div class="bfb-line bfb-mt">Leg diese Hülle als zweite rein. <b>Danach noch eine, die schenken wir dir.</b></div>';
    } else if (r === 2) {
      h += '<div class="bfb-line bfb-mt"><b>Leg diese Hülle rein, eine davon schenken wir dir.</b></div>';
    }
    panel.innerHTML = h + codeHinweis();
    var img = panel.querySelector('.bfb-pimg');
    if (img) { if (C.img) img.src = C.img; else img.remove(); }
  }

  /* ---------- Handymodell merken und vorausfuellen ---------- */
  function hulk$() { return window.hulkapps_jQuery || window.jQuery; }
  function esc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/["\\]/g, ''); }
  function darfMerken() {
    // Im Zweifel nein (Sven 08.10.): ohne Shopifys Einwilligungs-API wird nichts gemerkt.
    try { var cp = window.Shopify && Shopify.customerPrivacy; return !!(cp && cp.preferencesProcessingAllowed && cp.preferencesProcessingAllowed()); } catch (e) { return false; }
  }
  var MAX_ALTER = 30 * 24 * 3600 * 1000;
  function merkeModell() {
    if (!darfMerken()) return;
    var s1 = document.querySelector('select[aria-label="Handymodell"]');
    if (!s1 || !s1.value) return;
    var s2 = document.querySelector('select[aria-label="' + esc(s1.value) + '"]');
    if (!s2 || !s2.value) return;
    LS.set('bfb_modell', { marke: s1.value, modell: s2.value, ts: Date.now() });
  }
  function gemerktesModell() {
    var m = LS.get('bfb_modell');
    if (!m) return null;
    if (!m.marke || !m.modell || !m.ts || Date.now() - m.ts > MAX_ALTER || !darfMerken()) {
      try { localStorage.removeItem('bfb_modell'); } catch (e) {}
      return null;
    }
    return m;
  }
  function fuelleModell() {
    var m = gemerktesModell(); if (!m) return;
    var versuche = 0;
    var iv = setInterval(function () {
      var s1 = document.querySelector('select[aria-label="Handymodell"]'), $ = hulk$();
      if (++versuche > 25) { clearInterval(iv); return; }
      if (!s1 || !$) return;
      clearInterval(iv);
      if (s1.value) return; // Kunde hat schon selbst gewaehlt
      var hat = [].some.call(s1.options, function (o) { return o.value === m.marke; });
      if (!hat) return;
      $(s1).val(m.marke).trigger('change');
      setTimeout(function () {
        var s2 = document.querySelector('select[aria-label="' + esc(m.marke) + '"]');
        if (!s2 || ![].some.call(s2.options, function (o) { return o.value === m.modell; })) return;
        $(s2).val(m.modell).trigger('change');
        var box = document.querySelector('[id^="hulkapps_custom_options_"]');
        if (box && !document.querySelector('.bfb-kept')) {
          var chip = el('div', 'bfb-kept', '📱 <b></b> übernommen <a href="#">ändern</a>');
          chip.querySelector('b').textContent = m.modell;
          chip.querySelector('a').addEventListener('click', function (e) { e.preventDefault(); chip.remove(); s1.focus(); s1.scrollIntoView({ block: 'center', behavior: 'smooth' }); });
          box.parentNode.insertBefore(chip, box);
        }
      }, 700);
    }, 400);
  }

  /* ---------- Fenster nach dem Reinlegen (Vorbild Snocks, Patrick 08.10.) ----------
   * Das Theme oeffnet nach dem Reinlegen den Warenkorb. Wir halten ihn kurz zurueck und zeigen zuerst
   * das Fenster mit Bestsellern. "Zum Warenkorb" oeffnet ihn danach ganz normal. */
  var sheet = null;
  // Shopify-Vorschau: unten liegt die Draft-Leiste (Name hat sich 2026 geaendert, beide pruefen).
  function vorschau() { return !!(document.getElementById('preview-bar-iframe') || document.getElementById('PBarNextFrameWrapper')); }
  function drawer() { return document.getElementById('mini-cart'); }
  function drawerOffen() { var d = drawer(); return !!(d && d.hasAttribute('open')); }
  function oeffneWarenkorb() {
    if (drawerOffen()) return;
    var knopf = document.querySelector('[aria-controls="mini-cart"]');
    if (knopf) knopf.click(); else location.href = '/cart';
  }
  function schliesseDrawer() {
    var d = drawer(); if (!d || !drawerOffen()) return;
    var x = d.querySelector('[data-action="close"], .drawer__close-button, button[aria-label*="chlie"]');
    if (x) x.click();
  }
  function zeigeHold(an) { document.documentElement.classList.toggle('bfb-hold', an); }
  function schliesseSheet(zumWarenkorb) {
    if (sheet) sheet.classList.remove('on');
    document.documentElement.classList.remove('bfb-lock');
    if (zumWarenkorb) { zeigeHold(false); oeffneWarenkorb(); }
    else { schliesseDrawer(); setTimeout(function () { zeigeHold(false); }, 450); }
  }
  function zeigeSheet(n) {
    if (n < 1) return;
    if (!sheet) {
      sheet = el('div', 'bfb-sheet');
      document.body.appendChild(sheet);
    }
    // Texte und Knopf nach Patricks Vorgabe 08.10.: Erfolg zeigen, grosser Knopf fuehrt zur Gratis-Huelle.
    var r = n % 3, t, s, ja;
    if (r === 1) { t = '🎉 Hülle 1 ist drin! Leg noch 2 dazu, eine davon schenken wir dir.'; s = 'Egal welche Designs, auch mit eigenem Foto.'; ja = 'Ja, ich such mir noch 2 aus'; }
    else if (r === 2) { t = '🎉 Leg jetzt noch eins dazu, das schenken wir dir!'; s = 'Die nächste Hülle ist umsonst. Such dir irgendein Design aus, auch mit eigenem Foto.'; ja = 'Ja, ich sichere mir die Gratis-Hülle'; }
    else { t = '🎉 Geschafft! Eine Hülle ist geschenkt.'; s = 'Und es geht weiter: noch 2 Hüllen, dann ist die nächste wieder gratis.'; ja = 'Ja, ich will noch eine reinlegen'; }
    sheet.innerHTML = '<div class="bfb-sh-bd"></div><div class="bfb-sh">' +
      '<button type="button" class="bfb-sh-x" aria-label="Schließen">✕</button>' +
      punkte(n) + '<div class="bfb-sh-t">' + t + '</div><div class="bfb-sh-s">' + s + '</div>' +
      '<div class="bfb-sh-hint"></div><div class="bfb-sh-grid"></div>' + codeHinweis() +
      '<div class="bfb-sh-foot"><a class="bfb-sh-cart" href="/collections/bestseller">' + ja + '</a>' +
      '<button type="button" class="bfb-sh-no">Zum Warenkorb</button></div></div>';
    var m = gemerktesModell();
    if (m) {
      var hint = sheet.querySelector('.bfb-sh-hint');
      hint.innerHTML = '📱 Dein <b></b> ist schon eingetragen.';
      hint.querySelector('b').textContent = m.modell;
    }
    var grid = sheet.querySelector('.bfb-sh-grid');
    (C.bs || []).slice(0, 4).forEach(function (x) {
      var a = el('a', 'bfb-sh-card');
      a.href = x.u;
      var img = el('img'); img.alt = ''; img.loading = 'lazy'; if (x.img) img.src = x.img;
      var tt = el('span', 'bfb-sh-ct'); tt.textContent = x.t || '';
      var pr = el('span', 'bfb-sh-cp'); pr.textContent = x.pr ? euro(x.pr) : '';
      var go = el('span', 'bfb-sh-cg'); go.textContent = 'Ansehen →';
      a.appendChild(img); a.appendChild(tt); a.appendChild(pr); a.appendChild(go);
      grid.appendChild(a);
    });
    if (!grid.children.length) grid.remove();
    function nein() { schliesseSheet(false); }
    sheet.querySelector('.bfb-sh-x').addEventListener('click', nein);
    sheet.querySelector('.bfb-sh-bd').addEventListener('click', nein);
    sheet.querySelector('.bfb-sh-no').addEventListener('click', function () { schliesseSheet(true); });
    sheet.classList.toggle('pv', vorschau());
    document.documentElement.classList.add('bfb-lock');
    requestAnimationFrame(function () { sheet.classList.add('on'); });
  }

  // Das Theme oeffnet nach dem Reinlegen den Warenkorb. Wir lassen es oeffnen, halten ihn aber unsichtbar
  // (bfb-hold), bis der Kunde im Fenster entscheidet. Nicht am open-Attribut ziehen: das Theme setzt es
  // sofort zurueck, das lief am 08.10. in eine Endlosschleife und fror die Seite ein.
  // Sven 08.10.: Fallschirm, falls /cart.js haengt. Fenster nur, wenn eine Aktions-Huelle dazukam.
  var haltTimer = null, fallschirm = null;
  function nachDemReinlegen() {
    merkeModell();
    var vorher = stand;
    zeigeHold(true);
    clearTimeout(fallschirm);
    fallschirm = setTimeout(function () { if (!sheet || !sheet.classList.contains('on')) zeigeHold(false); }, 4000);
    holeCart().then(function (cart) {
      stand = zaehlen(cart);
      zeigeLeiste(stand); malePanel(stand);
      clearTimeout(haltTimer);
      haltTimer = setTimeout(function () {
        if (stand > vorher && stand > 0) zeigeSheet(stand); else zeigeHold(false);
      }, 600);
    }).catch(function () { zeigeHold(false); });
  }
  // Zurueck-Taste aus dem Browser-Cache: altes Fenster nicht mit altem Stand stehen lassen.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { if (sheet) sheet.classList.remove('on'); document.documentElement.classList.remove('bfb-lock', 'bfb-hold'); }
  });

  /* Reinlegen erkennen: fetch und XHR auf /cart/add */
  function istAdd(url, method) { return /\/cart\/add/.test(String(url || '')) && String(method || 'GET').toUpperCase() === 'POST'; }
  if (window.fetch) {
    var f0 = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href));
      var method = (init && init.method) || (input && input.method);
      var p = f0.apply(this, arguments);
      if (istAdd(url, method)) p.then(function (res) { if (res && res.ok) setTimeout(nachDemReinlegen, 50); }).catch(function () {});
      return p;
    };
  }
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__bfbAdd = istAdd(u, m); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__bfbAdd) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) setTimeout(nachDemReinlegen, 50); });
    return xs.apply(this, arguments);
  };

  /* ---------- Start ---------- */
  var stand = 0;
  function start() {
    try {
      if (istAktionsProdukt) { baueProduktseite(); fuelleModell(); }
      holeCart().then(function (cart) { stand = zaehlen(cart); zeigeLeiste(stand); malePanel(stand); }).catch(function () { malePanel(0); });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
